import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
const MIN_VIEWERS = 124;
const MAX_VIEWERS = 208;
export function BibleLiveViewers() {
  const [viewers, setViewers] = useState(158);
  useEffect(() => {
    let timeoutId: number;
    const schedule = () => {
      timeoutId = window.setTimeout(() => {
        setViewers(current => {
          const delta = Math.floor(Math.random() * 7) - 3;
          const next = current + delta;
          if (next < MIN_VIEWERS) return MIN_VIEWERS + Math.abs(delta);
          if (next > MAX_VIEWERS) return MAX_VIEWERS - Math.abs(delta);
          return next;
        });
        schedule();
      }, 2800 + Math.random() * 2600);
    };
    schedule();
    return () => window.clearTimeout(timeoutId);
  }, []);
  return <motion.aside role="status" aria-live="polite" initial={{
    opacity: 0,
    y: -14,
    scale: 0.96
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.6,
    delay: 1,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed right-3 top-[72px] z-30 rounded-xl border border-[#7b663b] bg-[#101013f2] px-3 py-2 shadow-[0_14px_34px_rgba(0,0,0,0.55)] backdrop-blur-md md:right-5 md:top-[88px]" data-id="element-23" data-mp="2gq8ffsyyjrbw">
      <div className="flex items-center gap-2.5" data-id="element-24" data-mp="2c0hrbqpb6yjf">
        <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-25" data-mp="271dg6uitqqqg">
          <span aria-hidden="true" className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#e995b3] opacity-70" data-id="element-26" data-mp="26ztxyydly5m1" />
          <span aria-hidden="true" className="relative inline-flex h-2 w-2 rounded-full bg-[#e995b3] shadow-[0_0_8px_#e995b3]" data-id="element-27" data-mp="1eekadxqkv19l" />
        </span>

        <Eye aria-hidden="true" className="h-3.5 w-3.5 text-[#e9c769]" data-id="element-28" data-mp="1ob5gkmec2if0" />

        <p className="text-[11px] leading-tight text-[#beb9b0]" data-id="element-29" data-mp="10lum1mnktk9b">
          <motion.span key={viewers} initial={{
          opacity: 0.4,
          y: -4
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25
        }} className="inline-block font-[Georgia,serif] text-[15px] font-bold text-[#f7f2e8]" data-id="element-30" data-mp="10k04mibika9z">
            {viewers}
          </motion.span>{' '}
          personas viendo
          <span className="block text-[9px] uppercase tracking-[0.14em] text-[#e9c769]" data-id="element-31" data-mp="1u48kit9160hs">
            esta página ahora
          </span>
        </p>
      </div>
    </motion.aside>;
}